import { useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { Box } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';
import PropTypes from 'prop-types';
import React from 'react';

// Add semantic colors here. Also add to props.
const getPaletteColorFromSemanticColor = (theme, color) => {
  switch (color) {
    case 'subtleLightest':
      return theme.palette.subtle.lightest;
    case 'secondary':
      return theme.palette.facet.colorSunset500;
    default:
      return theme.palette.divider;
  }
};

export const LeftBorderedBox = ({
  children, rounded, borderColor, backgroundColor, ...restProps
}) => {
  const theme = useTheme();

  const borderColorFromPalette = getPaletteColorFromSemanticColor(theme, borderColor);
  const backgroundColorFromPalette = getPaletteColorFromSemanticColor(theme, backgroundColor);

  return (
    <Box
      sx={{
        width: '100%',
        background: backgroundColorFromPalette,
        borderTopRightRadius: rounded ? theme.spacing(2) : theme.spacing(0),
        borderBottomRightRadius: rounded ? theme.spacing(2) : theme.spacing(0),
        borderLeft: `5px ${borderColorFromPalette} solid`,
      }}
      {...restProps}
    >
      {children}
    </Box>

  );
};

LeftBorderedBox.defaultProps = {
  borderColor: undefined,
  backgroundColor: undefined,
  rounded: true,
};

LeftBorderedBox.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  rounded: PropTypes.bool,
  borderColor: PropTypes.oneOf(['subtleLightest', 'secondary']),
  backgroundColor: PropTypes.oneOf(['subtleLightest', 'secondary']),
};
